import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { Customer, Salutation, Address, PaymentTypes, ShipmentTypes, DisplayShoppingCart, Order } from "../../../models"


@Component({
	selector: 'complete-payment-presentation',
	templateUrl: "./complete-payment.presentation.html",
	styles: [require("./complete-payment.presentation.scss")]
})
export class CompletePaymentPresentation {
	@Input() order: Order
	@Output() delayPayment = new EventEmitter<string>();
	@Output() completePayment = new EventEmitter<string>();

	public constructor() {

	}

}



// WEBPACK FOOTER //
// ./src/app/components/checkout-components/complete-payment/complete-payment.presentation.ts